import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { Markdown } from '~/components/markdown';

import { CaseStudyOutcomeHighlight } from '../models/case-study-content';

export function OutcomeHighlightsSection({ outcomeHighlights }: { outcomeHighlights: CaseStudyOutcomeHighlight[] }) {
  return (
    <Box as='section' backgroundColor='blue.100' paddingY={{ base: '24px', md: '40px' }}>
      <ContentContainer>
        <Flex flexDirection={{ base: 'column', md: 'row' }} gap={{ base: '24px', md: '32px' }}>
          {outcomeHighlights.map((outcomeHighlight) => (
            <Box key={outcomeHighlight.title} flexBasis={{ base: '100%', md: `calc((100% / 3) - 32px / 3)` }}>
              <Box
                alignItems={{ base: 'center', md: 'unset' }}
                display='flex'
                flexDirection={{ base: 'row', md: 'column' }}
              >
                <Heading as='p' color='blue.400' fontWeight='600' size='marketing-5xl'>
                  {outcomeHighlight.title}
                </Heading>

                <Text fontSize='24px' marginLeft={{ base: '8px', md: 'unset' }}>
                  {outcomeHighlight.subtitle}
                </Text>
              </Box>

              <Box marginTop='8px'>
                <Markdown markdownText={outcomeHighlight.body} />
              </Box>
            </Box>
          ))}
        </Flex>
      </ContentContainer>
    </Box>
  );
}
